import { render, staticRenderFns } from "./myApplications.vue?vue&type=template&id=5b2783ac&scoped=true"
import script from "./myApplications.vue?vue&type=script&lang=js"
export * from "./myApplications.vue?vue&type=script&lang=js"
import style0 from "./myApplications.vue?vue&type=style&index=0&id=5b2783ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2783ac",
  null
  
)

export default component.exports